import { Component, ViewChild, OnDestroy, OnInit, NgZone } from "@angular/core";
import { NgbDropdown } from "@ng-bootstrap/ng-bootstrap";
import { Subscription } from "rxjs";
import { LoadManagerService } from "../loadingOverlay/loadManager.service";
import { OfficeSelectorService } from "../officeSelector/officeSelector.service";
import { BaseComponent } from "../baseComponent";
import { ImpersonationProfile, ImpersonationService } from "src/app/auth/apigee/impersonation.service";
import { ApigeeService } from "src/app/auth/apigee/apigee.service";

@Component({
  selector: "impersonation-menu",
  templateUrl: "./impersonationMenu.component.html",
  styleUrls: ["./impersonationMenu.component.css"],
  standalone: false
})
export class ImpersonationMenuComponent extends BaseComponent implements OnInit, OnDestroy {
  @ViewChild(NgbDropdown) private dropdown: NgbDropdown;
  private loadCounter: number = 0;
  public get loading(): boolean { return this.loadCounter > 0; }
  private officeTeam: ImpersonationProfile[] = [];
  public profiles: ImpersonationProfile[] = [];
  private performingImpersonation: boolean = false;
  private officeChangedSubscription: Subscription;

  public get text(): string {
    return "Ver como {0}".format(this.impersonationService.getUserDisplayName());
  }

  public get impersonationEnabled(): boolean {
    return this.impersonationService.canImpersonate;
  }

  constructor(zone: NgZone, private apigeeService: ApigeeService, private impersonationService: ImpersonationService, private loadManagerService: LoadManagerService,
    private officeSelectorService: OfficeSelectorService) {
    super(zone);
  }

  public ngOnInit() {
    this.officeChangedSubscription = this.officeSelectorService.selectedOfficeUpdated.subscribe((office) => {
      this.updateOfficeTeam();
    });

    if (this.officeSelectorService.selectedOffice) {
      this.updateOfficeTeam();
    }
  }

  private getOfficeId(): string {
    let office = this.officeSelectorService.selectedOffice;
    return office ? office.id : null;
  }

  private async updateOfficeTeam() {
    let requestOfficeId = this.getOfficeId();
    this.officeTeam = [];
    this.loadCounter++;
    try {
      let officeTeam = (await this.impersonationService.getImpersonableProfiles())
        .sort((a, b) => a.name.toLocaleLowerCase().localeCompare(b.name.toLocaleLowerCase()));
      if (requestOfficeId == this.getOfficeId()) {
        this.officeTeam = officeTeam;
      }
    } catch (error) {
      if (requestOfficeId == this.getOfficeId()) {
        this.profiles = [];
      }
    }
    finally {
      this.loadCounter--;
      if (this.loadCounter < 0) this.loadCounter = 0;
    }
    this.updateProfiles();
  }

  private updateProfiles() {
    let profiles = this.officeTeam.filter(x => x.nif != this.apigeeService.userInfo.nameid)
    if (this.impersonationService.isImpersonating) {
      profiles = profiles.filter(x => x.nif != this.impersonationService.getNif());
      let backProfiles = [new ImpersonationProfile(null, "Volver a mi perfil", null, null, null)];
      profiles = backProfiles.concat(profiles);
    }
    this.profiles = profiles;
  }

  public ngOnDestroy() {
    this.officeChangedSubscription.unsubscribe();
  }

  public async dropdownToggleClick() {
    if (this.performingImpersonation) {
      this.dropdown.close();
    } else {
      if (this.dropdown.isOpen()) {
        this.updateProfiles();
      }
    }
  }

  public enableAutoClose() {
    this.zone.run(() => this.dropdown.autoClose = true);
  }

  public disableAutoClose() {
    this.zone.run(() => this.dropdown.autoClose = false);
  }

  public openDropdown() {
    this.zone.run(() => this.dropdown.open());
  }

  public closeDropdown() {
    this.zone.run(() => this.dropdown.close());
  }

  public async impersonate(event: Event, profile: ImpersonationProfile) {
    if (event) event.stopPropagation();
    this.dropdown.close();
    this.performingImpersonation = true;
    this.loadManagerService.incLoadRequest();
    try {
      if (profile.nif == null) {
        this.impersonationService.clearImpersonation();
      } else {
        await this.impersonationService.impersonate(profile);
      }
    } finally {
      this.loadManagerService.decLoadRequest();
      this.performingImpersonation = false;
    }
  }
}
